import { mapState } from 'vuex';

export default {
    name: 'wai-logotype',
    props: {
        small : Boolean,
        big : Boolean
    },

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },

   

    computed: mapState({
        auth : state => state.auth,

        age : function(state){

            if (typeof state.tempage != 'undefined'){
                return state.tempage
            }

            return state.userinfo?.userinfo?.age || state.age

        },

        agecluster : function(){
            if(this.age <= 3) return '2'
            if(this.age > 3 && this.age <= 5) return '4'
            if(this.age > 5 && this.age <= 7) return '8'
            if(this.age > 7) return '9'
        }
    }),

    methods : {
        
    },
}